import { render, staticRenderFns } from "./H5NavBar.vue?vue&type=template&id=b52cf4d0&scoped=true&"
import script from "./H5NavBar.vue?vue&type=script&lang=ts&"
export * from "./H5NavBar.vue?vue&type=script&lang=ts&"
import style0 from "./H5NavBar.vue?vue&type=style&index=0&id=b52cf4d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52cf4d0",
  null
  
)

export default component.exports